'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DocSigner() {
}
export { $c_Lpresto_types$DocSigner as $c_Lpresto_types$DocSigner };
$p = $c_Lpresto_types$DocSigner.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DocSigner;
/** @constructor */
function $h_Lpresto_types$DocSigner() {
}
export { $h_Lpresto_types$DocSigner as $h_Lpresto_types$DocSigner };
$h_Lpresto_types$DocSigner.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
var $d_Lpresto_types$DocSigner = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i(0, "presto.types$DocSigner", ({
  jM: 1,
  b: 1,
  c: 1,
  a: 1,
  q: 1
}));
export { $d_Lpresto_types$DocSigner as $d_Lpresto_types$DocSigner };
//# sourceMappingURL=presto.types$-Doc-Signer.js.map
